import { SimpleModalProps } from '../simpleModal'
import { useTranslator } from '../../translator/hook'
import Modal from 'react-modal'
import { BigButton } from '../../buttons/bigButton'
import '../../../styles/modal.css'
import './connectManualModal.css'
import connectManual from '../../../assets/connect-manual.svg'
import ReconnectIcon from '../../icons/reconnectIcon'
import { toast } from 'react-toastify'
import { SmallButton } from '../../buttons/smallButton'

interface ConnectManualModalProps extends Pick<SimpleModalProps, 'onClose'> {
  isOpen: boolean
  onClose(): void
  code: string
}

export const ConnectManualModal = ({
  isOpen,
  onClose,
  code,
}: ConnectManualModalProps) => {
  Modal.setAppElement('#root')
  const { t } = useTranslator()

  return (
    <Modal
      className="modal-content"
      isOpen={isOpen}
      contentLabel="Connect Modal"
      onRequestClose={onClose}
      style={{
        overlay: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          zIndex: 862, //NOTE:連携モーダルは862に設定
        },
      }}
    >
      <div className="connect-manual-modal-container">
        <ReconnectIcon className="connect-manual-modal-circle" />
        <div className="connect-manual-modal-header">
          <span className="connect-manual-modal-title ">
            {t('linkage_connection_code').replace(/{CODE}/g, code)}
          </span>
          <SmallButton
            className="linkage-copy-small-button"
            onClick={() => {
              navigator.clipboard.writeText(code)
              toast.success(t('linkage_code_copied'))
            }}
          >
            {t('linkage_copy_button')}
          </SmallButton>
        </div>

        <div className="connect-manual-modal-content">
          <div className="connect-manual-modal-card">
            <div className="connect-manual-modal-card-title">
              {t('connect_help')}
            </div>
            <div className="connect-manual-modal-card-image card-image">
              <img src={connectManual} alt={'connect'} />
            </div>
          </div>
        </div>
      </div>
      <div>
        <BigButton onClick={onClose}>{t('close_button')}</BigButton>
      </div>
    </Modal>
  )
}
